import { http } from '../services';

class ArquivoService {
    arquivoForm() {
        return http.get('/arquivos/form');
    }

    getArquivo(projeto) {
        return http.get(`/arquivos/${projeto}`);
    }

    async validarQuantidadeDePaginas(arquivo, tipo, csrfToken) {
        const formData = new FormData();
        formData.append('arquivo', arquivo);
        formData.append('tipo', tipo);
        const request = await fetch(http.getUrl('/arquivos/validar-quantidade-de-paginas'), {
            method: 'PUT',
            body: formData,
            headers: {
                'CSRF-Token': csrfToken,
            },
            credentials: 'include',
        });
        return request.json();
    }

    getLinkArquivo(projeto) {
        return http.getUrl(`/arquivos/link/${projeto}`);
    }
}

const arquivoService = new ArquivoService();
export default arquivoService;
